// extracted by mini-css-extract-plugin
export default {"container":"cr-z","heading":"dr-z","text":"er-z","info":"fr-z","link":"gr-z","fullMaxWidth":"hr-z"};